#import "../../../../../core-entity/graphql/fragments/widget-fragment-full.graphql"

mutation WidgetStagesetUpdate($input: WidgetStagesetUpdateInput!) {
    widgetStagesetUpdate(input: $input) {
        sidebar {
            ...WidgetFragmentFull
        }
        workspace {
            ...WidgetFragmentFull
        }
    }
}
